import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'rentware-checkbox',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareCheckbox {
  @Prop() id: string;
  @Prop() name: string;
  @Prop() label?: string;
  @Prop() labelHtml?: string;
  @Prop() checked: boolean;
  @Prop() placeholder?: string;
  @Prop() disabled?: boolean;
  @Prop() required?: boolean;
  @Prop() onInput?: any;
  @Prop() onBlur?: any;
  @Prop() onFocus?: any;
  @Prop() inputRef?: any;
  @Prop() labelRef?: any;
  @Prop() inputUnRef?: any;
  @Prop() error: boolean = false;
  @Prop() fixedStyle: boolean = false;
  @Prop() termsStyle: boolean = false;
  inputInternalRef?: any;

  disconnectedCallback() {
    if (this.inputUnRef) {
      this.inputUnRef(this.inputInternalRef, this.name);
    }
  }

  get labelOuterClass() {
    let labelClass = 'CheckboxContainer';
    if (this.fixedStyle) labelClass += 'FixedStyle';
    if (this.termsStyle) labelClass += ' ContainerTerms';
    if (this.error && !this.checked) labelClass += ' ContainerError';
    if (this.checked) labelClass += ' Selected';
    return labelClass;
  }

  get labelInnerClass() {
    let labelClass = 'Label';
    if (this.termsStyle) labelClass += ' Terms';
    return labelClass;
  }

  get boxClass() {
    let boxClass = 'CheckboxField';
    if (this.fixedStyle) boxClass += 'FixedStyle';
    return boxClass;
  }

  render() {
    return (
      <label class={this.labelOuterClass} ref={el => this.labelRef?.(el)}>
        <input
          type="checkbox"
          id={this.id}
          name={this.name}
          checked={this.checked}
          placeholder={this.placeholder}
          disabled={this.disabled}
          required={this.required}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          onInput={this.onInput}
          ref={(el: HTMLInputElement) => {
            this.inputInternalRef = el;
            if (this.inputRef) {
              this.inputRef(el);
            }
          }}
        />

        <div class={this.boxClass} />

        {this.label && <span class={this.labelInnerClass}>{this.label}</span>}

        {this.labelHtml && <span class={this.labelInnerClass} innerHTML={this.labelHtml} />}
      </label>
    );
  }
}
